module.exports = __webpack_public_path__ + "img/FM.7c54d1d2.svg";